import { c as _c } from "react/compiler-runtime";
import { Chips, Separator, TextInput, useTranslationContext } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { isEmptyArray } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
import { getFilterFieldName } from '../../utils/getFilterFieldName';
export type TextFilterProps = EagFilterProps & {
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function TextFilter(props) {
  const $ = _c(24);
  const t = useTranslationContext();
  const model = props.value[FILTER_VALUE_KEY] as string | null ?? null;
  let t0;
  if ($[0] !== props) {
    t0 = changeValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: changeValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onChange = t0;
  let t1;
  if ($[2] !== onChange) {
    t1 = {
      setFilterValue: onChange,
      defaultValue: null
    };
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t1);
  let t2;
  if ($[4] !== model) {
    t2 = intersection([model], quickFiltersConst);
    $[4] = model;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isQuickFilterValue = t2 as string[];
  let t3;
  if ($[6] !== isQuickFilterValue || $[7] !== onChipsChange || $[8] !== props) {
    t3 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("text-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[6] = isQuickFilterValue;
    $[7] = onChipsChange;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.column || $[11] !== t) {
    t4 = t("page.datagrid.filter.textPlaceholder", {
      field: getFilterFieldName(props.column)
    });
    $[10] = props.column;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = isEmptyArray(isQuickFilterValue) ? model : null;
  const t6 = props.isDisabled;
  let t7;
  if ($[13] !== props) {
    t7 = suffixTestId("text-filter", props);
    $[13] = props;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onChange || $[16] !== props.isDisabled || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <TextInput placeholder={t4} value={t5} onChange={onChange} isDisabled={t6} data-testid={t7} />;
    $[15] = onChange;
    $[16] = props.isDisabled;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t8) {
    t9 = <VStack>{t3}{t8}</VStack>;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}